var FORM_ACTION_STATUS = /* @__PURE__ */ ((FORM_ACTION_STATUS2) => {
  FORM_ACTION_STATUS2["PENDING"] = "pending";
  FORM_ACTION_STATUS2["SUCCESS"] = "success";
  FORM_ACTION_STATUS2["FAILURE"] = "failure";
  return FORM_ACTION_STATUS2;
})(FORM_ACTION_STATUS || {});
export {
  FORM_ACTION_STATUS
};
//# sourceMappingURL=form-config.js.map
